<template>
  <div>
    <label
      class="mb-1 block text-left text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <InputSelect
      v-model="value"
      :options="computedOptions"
      :has-error="hasError"
      :disabled="disabled"
    />
    <p
      v-if="hasError"
      class="mt-1 text-xs font-medium text-error"
    >
      {{ errorMessage }}
    </p>
    <div v-else-if="warning" class="mt-1 flex items-center">
      <IconExclamationCircleFilled
        class="mr-1 text-warning"
      />
      <span
        class="text-xs leading-tight text-background-fg/70"
      >
        {{ warning }}
      </span>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
  generic="TValue extends string | number | boolean"
>
import { useField } from "vee-validate"
import type { SelectOption } from "./InputSelect.vue"

const props = defineProps<{
  name: string
  options: Array<SelectOption<TValue>>
  label?: string
  disableNull?: boolean
  disabled?: boolean
  warning?: string
}>()

const { value, errorMessage } = useField<
  TValue | null | undefined // Undefined necessary as no guarantee field initiated with intial value. Also field may unmount and remount.
>(() => props.name, undefined, {
  initialValue: undefined,
})

const hasError = computed(() => !!errorMessage.value)

const computedOptions = computed(() => [
  ...(props.disableNull
    ? []
    : [{ value: null, label: "---" }]),
  ...props.options,
])
</script>
